import React, { Component } from 'react';
import Bind from 'lodash-decorators/bind';

import styles from './OurProducts.module.scss';

import { injectIntl } from 'react-intl';

import messages from './OurProducts.intl';

import { Container } from 'common/components/Layout/Layout';

import NavList from './Components/NavList/NavList';
import ProductBox from './Components/ProductBox/ProductBox';

import { observer } from 'mobx-react';
import { LARGE_NUMBER_OF_ITEMS } from 'common/consts/common';
@injectIntl
@observer
export default class OurProducts extends Component {
  state = {
    activeSlideIndex: 0,
    fadeInActive: false
  };

  constructor(props) {
    super(props);
    this.changeSlide = 0;
  }

  render() {
    const { activeSlideIndex, fadeInActive } = this.state;
    const { products, changeHeading } = this.props;

    if (fadeInActive) {
      this.changeSlide = activeSlideIndex;
    }

    return (
      <div className={styles.Container}>
        <Container>
          <div
            className={`${styles.Header} ${
              products.length > LARGE_NUMBER_OF_ITEMS ? styles.LotProducts : ''
            }`}
          >
            <h3 className={styles.HeaderTitle}>
              {changeHeading
                ? this.props.intl.formatMessage(messages.headingProjects)
                : this.props.intl.formatMessage(messages.headingProducts)}
            </h3>
            {products && (
              <NavList
                products={products}
                onChangeSlide={this.setActiveSlide}
                activeSlideIndex={activeSlideIndex}
                className={styles.HeaderList}
                fadeInActive={fadeInActive}
              />
            )}
          </div>
        </Container>
        {products.length && (
          <div
            className={`${styles.BackgroundWrapper}`}
            style={products[this.changeSlide].gradient}
          >
            <Container>
              <ProductBox
                product={products[activeSlideIndex]}
                isFadeInActive={this.isFadeInActive}
                activeSlideIndex={activeSlideIndex}
              />
            </Container>
          </div>
        )}
      </div>
    );
  }

  @Bind()
  setActiveSlide(index) {
    this.setState({
      activeSlideIndex: index
    });
  }

  @Bind()
  isFadeInActive(bool) {
    this.setState({
      fadeInActive: bool
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Products/OurProducts.js